import React, { FC } from 'react';

import { Icon } from '@iconify/react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ANNUAL_PLAN_DISCOUNT } from '~/constants/products';
import Benefits from '~/modules/feature-access/components/Benefits';
import { getBenefitsList } from '~/modules/feature-access/helpers';
import projectConfig from '~/projects/config';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

const OrderDescription: FC = () => {
  const { t } = useTranslation('modal');

  return (
    <div className={styles.container}>
      <Typography
        variant={Typographies.LABEL_LARGE}
        component="div"
        className={styles.label}
      >
        {t('modal:upgrade_sub.label_v2', {
          amount: ANNUAL_PLAN_DISCOUNT,
          defaultValue: 'Save {{amount}} Annually',
        })}
      </Typography>

      <Typography
        variant={Typographies.TITLE_LARGE}
        component="div"
        className={styles.title}
      >
        <Icon icon="material-symbols:all-inclusive" />
        <span>
          {t('modal:upgrade_sub.title', {
            project: projectConfig.getProjectName(),
            defaultValue: 'Upgrade To {{project}} Unlimited',
          })}
        </span>
      </Typography>

      <Benefits benefits={getBenefitsList(t)} isFullList />
    </div>
  );
};

export default OrderDescription;
